import { useState } from 'react';

export const useModalControls = (modalOpenDefaultState = false) => {
    const [isVisible, setIsVisible] = useState<boolean>(modalOpenDefaultState);

    const toggleModalVisibility = () => {
        setIsVisible((s: boolean) => !s);
    };

    return {
        isVisible,
        toggleModalVisibility,
    };
};

export type ModalControls = {
    isVisible: boolean;
    toggleModalVisibility: () => void;
};
